import { uiActions } from '../ui-slice';
import { form5Actions } from './form5-slice';
import { doNavigation } from '../../utils/helper-functions';

export const form5Transaction = (
  values,
  currentStep,
  navigateHook,
) => {
  return (dispatch) => {
    dispatch(uiActions.setLoaderStatus({ type: 'simple' }));
    dispatch(form5Actions.setFormData(values));
    doNavigation(currentStep, 'forward', navigateHook, dispatch, true);
  };
};
